export class CourseVariable {
  key: string;
  value: string | null;
  languageCode?: LanguageCode;
}

export enum LanguageCode {
  DE = 'DE',
  EN = 'EN',
}
